import EmployeeSelect from '@/components/Form/Shared/EmployeeSelect'
import ProductGroupSelect from '@/components/Form/Shared/ProductGroupSelect'
import GokuDataGrid from '@/components/GokuDataGrid'
import SubHeaders from '@/components/Headers/SubHeaders'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import useQueryClientCallback from '@/hooks/useQueryClientCallback'
import AddIcons from '@/icons/AddIcons'
import DeleteOutlineIcons from '@/icons/DeleteOutlineIcons'
import EditIcons from '@/icons/EditIcons'
import { paths } from '@/utils/path'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { IAction } from 'vnetwork-ui/dist/components/GokuDataGrid/Actions'
import { deleteKPIEmployee, getKPIEmployees } from '../../services'
import columns from './columns'

const List = () => {
    const navigate = useNavigate()
    const { refetch } = useQueryClientCallback({
        reactQueryKeys: ['kpi.employees'],
    })
    const { t } = useTranslation()

    const { mutate: deleteMutate } = useMutationWithHandler(
        {
            mutationFn: deleteKPIEmployee,
        },
        {
            reactQueryKeys: QUERY_KEYS.KPI,
            successMessage: t('delete-success'),
            onSuccess: () => {
                refetch()
            },
        }
    )
    const dataGridActions: IAction<any>[] = [
        {
            onClick: () => {
                // navigate(
                //     generatePathDatacentral(paths.employeeUpdate, {
                //         id: row?.employee_id,
                //     })
                // )
            },
            title: t('edit'),
            color: 'info',
            icon: <EditIcons />,
        },
        {
            onClick: (row) => {
                deleteMutate(row?.kpi_configuration_id)
            },
            title: t('delete'),
            color: 'error',
            icon: <DeleteOutlineIcons />,
        },
    ]
    //     {
    //         onClick: (row) => {
    //             setConfirmation({
    //                 open: true,
    //                 title: t('confirm'),
    //                 description: t('resend-confirmation-warning'),
    //                 onConfirm: () => resend({ employee_id: row?.employee_id }),
    //             })
    //         },
    //         title: t('resend-confirmation'),
    //         color: 'success',
    //         icon: <LoadIcons />,
    //         disabled: (row) =>
    //             row?.employee_confirmed || row?.employee_status !== 1,
    //     },
    //     {
    //         onClick: (row) => {
    //             navigate(
    //                 generatePathDatacentral(paths.employeeUpdateAdvanced, {
    //                     id: row?.employee_id,
    //                 })
    //             )
    //         },
    //         title: t('edit-advanced'),
    //         color: 'warning',
    //         icon: <UserGroupIcons />,
    //     },
    //     {
    //         onClick: (row) => {
    //             setConfirmation({
    //                 open: true,
    //                 title: t('confirm'),
    //                 description: t('employee_disabled_warning'),
    //                 onConfirm: () =>
    //                     mutateAsync({ employee_id: row?.employee_id }),
    //             })
    //         },
    //         title: t('employee_disabled'),
    //         color: 'error',
    //         icon: <DeleteOutlineIcons />,
    //         disabled: (row) => row?.employee_status !== 1,
    //     },
    // ]
    return (
        <div>
            <SubHeaders
                actions={[
                    {
                        icon: <AddIcons />,
                        label: t('create-kpi-employee'),
                        onClick() {
                            navigate(paths.kpiCreate)
                        },
                    },
                ]}
                breadcrumbs={[
                    {
                        path: paths.employeesManage,
                        title: t('employee-manage'),
                    },
                ]}
            />

            <GokuDataGrid
                apiCall={(payload) => getKPIEmployees({ ...payload })}
                reactQueryKey="kpi.employees"
                columns={columns}
                dataGridProps={{
                    getRowId: (row) => row?.kpi_configuration_id,
                }}
                actions={dataGridActions}
                filterDefaultValues={{
                    product_group_name: [],
                    employee_id: [],
                }}
                handleAdd={() => {
                    navigate(paths.employeeCreate)
                }}
            >
                {({ control }) => (
                    <>
                        <ProductGroupSelect
                            name="product_group_name"
                            control={control}
                            multiple
                        />
                        <EmployeeSelect
                            name="employee_id"
                            control={control}
                            multiple
                        />
                    </>
                )}
            </GokuDataGrid>
        </div>
    )
}

export default List
